import React, { act, useState } from "react";

import AdminCointainer from "../../../containers/Admin";
import CountCard from "../../../components/CounterCard";
import CustomTabs from "../../../components/Tab";
import {bookingStatus} from "../../../common/staticData";
import {TripTabs} from "../../../common/tabs"
import Carousel from "../../../components/Carousel";
import BookingDetails from "../../Booking/view/bookingDetails";
const ClientViewPage = () => {
  const [activeTab, setActiveTab] = useState<string>("AllTrips");
  const [isExpanded] = useState(false);
  const items = [
    <div className="p-4 bg-gray-100 rounded-lg text-center">
      <h2 className="text-lg font-semibold">Slide 1</h2>
      <p>Loading Point: On the way</p>
    </div>,
    // <div className="p-4 bg-gray-100 rounded-lg text-center">
    //   <h2 className="text-lg font-semibold">Slide 2</h2>
    //   <p>Task Type: Empty - Warehouse</p>
    // </div>,
    // <div className="p-4 bg-gray-100 rounded-lg text-center">
    //   <h2 className="text-lg font-semibold">Slide 3</h2>
    //   <p>Route Status: Good ETA 15.45 Hrs</p>
    // </div>,
    // <div className="p-4 bg-gray-100 rounded-lg text-center">
    //   <h2 className="text-lg font-semibold">Slide 4</h2>
    //   <p>Clearance Status: Not Yet</p>
    // </div>,
  ]
  const handleTabChange = (tab: string) => {
    if (tab) {
      setActiveTab(tab);
    }
  };
  return (
    <div>
    
      <AdminCointainer>
        <div className="bg-white rounded-[20px] pt-2 ">
          {/* Booking Status Section */}
          <div className="flex justify-around p-4">
         <BookingDetails/>
          </div>
          <br />
          {/* Expandable Content */}
          <div
            className={`transition-all duration-300 ease-in-out overflow-hidden ${
              isExpanded ? "max-h-[500px]" : "max-h-0"
            }`}
          >
            <div className="flex justify-around p-2 mt-4">
            
          </div>
          </div>
          {/* Toggle Button */}
        
        </div>
        <br />
        <div>
          <CustomTabs
            tabs={TripTabs}
            initialActiveTab="AllTrips"
            onTabChange={handleTabChange}
          />
        </div>
        <br />

      

        
         
        <div>
          {activeTab === "" && (
            <div>
              <div className="w-full max-w-4xl">
        <h1 className="text-2xl font-bold text-center mb-6">Live Status</h1>
        <Carousel items={items} autoScroll={false} scrollInterval={4000} />
      </div>
            </div>
          )}
        </div>
      
      </AdminCointainer>
    </div>
  );
};

export default ClientViewPage;
